import { singleton } from "tsyringe";

// entities
import { AttendanceType } from "@/entities/attendance/domain/enums";
import type {
    SimplifiedAbsenceAttendanceDto,
    SimplifiedAttendanceDto,
} from "@/entities/attendance/domain/dtos";

@singleton()
export class AttendanceBehavior {
    public isAbsence = (
        attendance: SimplifiedAttendanceDto,
    ): attendance is SimplifiedAbsenceAttendanceDto => {
        return attendance.type === AttendanceType.Absence;
    };
}
